import React from 'react';

import { CHART_COLORS } from '../utils';
import {
	LegendWrapper,
	LegendItem,
	LegendColor,
	LegendName,
} from './Legend.styles';

export const Legend = () => {
	return (
		<LegendWrapper>
			<LegendItem>
				<LegendColor color={CHART_COLORS.GREY} />
				<LegendName>Original budget</LegendName>
			</LegendItem>
			<LegendItem>
				<LegendColor color={CHART_COLORS.AMBER} />
				<LegendName>Revised budget target</LegendName>
			</LegendItem>
			<LegendItem>
				<LegendColor colorSplit />
				<LegendName>YTD actuals</LegendName>
			</LegendItem>
		</LegendWrapper>
	);
};
